var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapNotVisited(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 101,
    viewBox: "0 0 84 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1250_6879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 38C78 50.5525 70.7121 62.5222 62.3563 72.0702C54.117 81.4852 45.1118 88.2366 42 90.4525C38.8882 88.2366 29.883 81.4852 21.6437 72.0703C13.2879 62.5222 6 50.5525 6 38C6 28.4522 9.79285 19.2955 16.5442 12.5442C23.2955 5.79285 32.4522 2 42 2C51.5478 2 60.7045 5.79285 67.4558 12.5442C74.2072 19.2955 78 28.4522 78 38Z",
    fill: "#2E2D2B",
    stroke: "#FFFEF9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9783 49.158C60.9783 52.1807 60.929 55.2075 60.9989 58.2302C61.0319 59.6622 60.114 60.5328 58.7804 60.4596C57.698 60.3985 56.6072 60.4596 55.5247 60.4473C54.1953 60.4351 53.6355 60.069 53.3721 58.7875C53.0552 57.2741 51.2853 56.7737 50.1658 57.7826C47.2311 60.4229 43.6791 61.3302 39.7813 61.2122C36.7767 61.1186 33.912 60.5043 31.2366 59.1455C26.8696 56.9243 23.9432 53.4337 22.3833 48.8691C20.3953 43.0475 20.3665 37.1607 22.4409 31.3676C24.7458 24.9235 29.4709 21.0708 36.1716 19.6225C40.6539 18.6543 45.1403 18.7479 49.4784 20.3833C54.858 22.4052 58.2495 26.2904 59.9741 31.6564C60.435 33.0884 59.5995 34.195 58.0602 34.2113C55.4589 34.2397 52.8617 34.2235 50.2605 34.2153C49.3426 34.2153 48.6964 33.7922 48.3466 32.946C48.3342 32.9176 48.326 32.885 48.3136 32.8565C47.1365 30.2162 45.239 28.5035 42.2015 28.3449C38.8758 28.174 36.2169 29.3456 34.4759 32.2463C33.4839 33.898 33.0188 35.7206 32.8295 37.6123C32.5332 40.513 32.6361 43.3892 33.5086 46.2044C33.7679 47.0466 34.1137 47.8521 34.5706 48.6088C36.1387 51.2124 38.4683 52.4777 41.5265 52.4451C42.6542 52.4329 43.7491 52.2417 44.7863 51.7779C47.4987 50.5656 48.5771 48.088 48.61 45.5739C48.6141 45.1589 48.396 45.1019 48.0543 45.106C46.8689 45.1141 45.6836 45.106 44.5023 45.106C44.2389 45.106 43.9755 45.1223 43.712 45.0979C42.683 45.0002 42.0039 44.3493 41.9669 43.3241C41.9175 42.0914 41.9175 40.8506 41.9586 39.618C41.9957 38.4463 42.716 37.775 43.9096 37.7466C44.7986 37.7222 45.6877 37.7425 46.5767 37.7425C50.491 37.7425 54.4093 37.7425 58.3236 37.7425C58.5211 37.7425 58.7187 37.7425 58.9163 37.7425C60.2745 37.771 60.9825 38.4504 60.9866 39.797C60.9989 42.9173 60.9866 46.0417 60.9866 49.162L60.9783 49.158Z",
    fill: "#FFFEF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1250_6879",
    x: 0,
    y: 0,
    width: 84,
    height: 100.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1250_6879"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1250_6879",
    result: "effect2_dropShadow_1250_6879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1250_6879",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapNotVisited);
export default __webpack_public_path__ + "static/media/map_not_visited.fc4009d918f0059af8ba26ed000781ba.svg";
export { ForwardRef as ReactComponent };